import { atom } from "jotai";

const globalDataPropertiesAtom = atom({
    collection: [],
    count: 0
});

export default globalDataPropertiesAtom